import { lte } from 'semver';
import store from '../store';
import { useRouter, useRoute } from 'vue-router'
import event from '../event';

const ifAuth = async (to, from, next) => {
  let dd = store.getters['auth/isAuth'];

  if (typeof localStorage.apiToken != 'undefined' && to.path !== '/login') {
    let isValidApiKey = await store.dispatch('auth/isValidApiKey');
    console.debug(isValidApiKey)
  } else if (typeof localStorage.apiToken == 'undefined' || !localStorage.apiToken || (typeof isValidApiKey != 'undefined' && !isValidApiKey) || !store.getters['auth/isAuth']) {
    if (window.getApp !== null && typeof (window.getApp) !== 'undefined') {
      localStorage.removeItem('fullName');
      localStorage.removeItem('lastVisitedPage');
      localStorage.removeItem('apiToken');
      localStorage.removeItem('authToken');

      window.getApp.$emit('APP_AUTH_CHECK_FAILED');
    }

    event.supressionFlag = true;

    setTimeout(() => {next('/login')}, 1500);
  }

  next()
};

export default [
  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/404'
    }
  },
  {
    path: '/404',
    meta: {
      public: true,
    },
    name: 'NotFound',
    component: () => import(
      `@/pages/NotFound.vue`
    )
  },
  {
    path: '/403',
    meta: {
      public: true,
    },
    name: 'AccessDenied',
    component: () => import(
      `@/pages/Deny.vue`
    )
  },
  {
    path: '/500',
    meta: {
      public: true,
    },
    name: 'ServerError',
    component: () => import(
      `@/pages/Error.vue`
    )
  },
  {
    path: '/login',
    meta: {
      public: true,
    },
    name: 'Login',
    component: () => import(
      `@/pages/Login.vue`
    )
  },
  {
    path: '/',
    meta: {},
    name: 'Root',
    redirect: {
      name: 'staffs/accounts'
    }
  },
  ...[
    { path: 'clients/employees', name: 'Employees', },
    { path: 'clients/clinics', name: 'Clinics', },
    { path: 'visits/list', name: 'Visits', },
    { path: 'staffs/list', name: 'Staffs', },
    { path: 'staffs/kpi', name: 'KPI', },
    { path: 'permission/roles', name: 'Roles', },
    { path: 'permission/levels', name: 'Levels', },
    { path: 'permission/objects', name: 'Objects', },
    { path: 'components/test', name: 'Test', },
    { path: 'dev/log', name: 'Log', },
    { path: 'shopEmployee/position', name: 'ShopEmployeePosition', },
    { path: 'shopEmployee/specialization', name: 'Specialization', },
    { path: 'shopEmployee/deactivationReason', name: 'DeactivationReason', },
    { path: 'shopEmployee/exhibition', name: 'Exhibition', },
    { path: 'shop/propertyType', name: 'PropertyType', },
    { path: 'visits/pollTemplates', name: 'PollTemplates', },
    { path: 'visits/pollQuests', name: 'PollQuests', },
    { path: 'visits/programs', name: 'Programs', },
    { path: 'visits/property', name: 'Property', },
    { path: 'visits/dataType', name: 'DataType', },
    { path: 'questions/:id/properties', name: 'QuestionProperty', },
    { path: 'questions/:id/answers', name: 'QuestionAnswers', },
    { path: 'dashboard/indexList', name: 'DashboardIndex', },
    { path: 'reports', name: 'Reports', },
    { path: 'dev/logError', name: 'LogError', },
    { path: 'shop/competitor', name: 'Competitor', },
    { path: 'staffs/accounts', name: 'Accounts', },
    { path: 'alidi', name: 'Alidi', },
    { path: 'territories/countries', name: 'Countries', },
    { path: 'territories/regions', name: 'Regions', },
    { path: 'territories/cities', name: 'Cities', },
    { path: 'email/signatureTemplate', name: 'EmailSignatureTemplate', },
    { path: 'email/template', name: 'EmailTemplate', },
    { path: 'shop/dobd', name: 'Dobd', },
    { path: 'staffs/position', name: 'StaffPosition', },
    { path: 'staffs/account-app-version', name: 'AccountAppVersion', },
    { path: 'employees/:id/employments', name: 'EmployeeEmployments', },
    { path: 'posm/list', name: 'POSM', },
    { path: 'appsettings/list', name: 'AppSettings', },
    { path: 'templatesSms/list', name: 'TemplatesSms', },
  ].map(r => ({
    path: `/${r.path}`,
    meta: { breadcrumb: true },
    name: r.path,
    beforeEnter: ifAuth,
    component: () => import(`@/pages/ui/${r.name}.vue`),
  })),
];



// WEBPACK FOOTER //
// ./src/router/paths.js